<template>
  <div class="account-verif-content" v-if="owner.uid">
    <div class="alert alert-primary account-verif-alert">
      {{ $t("accountVerification.endMessage") }}
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-6 mx-auto rounded-3 login-container">
          <div id="first">
            <div class="myform form ">
              <div
                class="alert alert-danger"
                role="alert"
                v-if="errorMessage != ''"
              >
                {{ errorMessage }}
              </div>
            </div>
            <!-- firstname -->
            <div class="row align-items-center">
              <div class="">
                <label for="inputfirstName" class="col-form-label"
                  >{{ $t("accountVerification.form.firstname") }}*
                </label>
              </div>
              <div class="">
                <input
                  v-model="firstname"
                  type="text"
                  id="inputfirstName"
                  class="form-control"
                  aria-describedby="firstnameHelpInline"
                />
              </div>
            </div>
            <br />
            <!-- lastname -->
            <div class="row align-items-center">
              <div class="">
                <label for="inputlastName" class="col-form-label"
                  >{{ $t("accountVerification.form.lastname") }}*
                </label>
              </div>
              <div class="">
                <input
                  v-model="lastname"
                  type="text"
                  id="inputlastName"
                  class="form-control"
                  aria-describedby="lastnameHelpInline"
                />
              </div>
            </div>
            <br />
            <!-- company address -->
            <div class="row align-items-center">
              <div class="">
                <label for="inputCompanyAddress" class="col-form-label"
                  >{{ $t("accountVerification.form.address") }}
                </label>
              </div>
              <div class="">
                <input
                  v-model="headquarters_address"
                  type="text"
                  id="inputCompanyAddress"
                  class="form-control"
                  aria-describedby="companyHelpInline"
                />
              </div>
            </div>
            <br />
          </div>
          <div class="alert alert-success" role="alert" v-if="isSuccess != ''">
            {{ $t("accountVerification.form.successMessage") }}
          </div>
          <div class="col-md-12 text-center ">
            <button
              :disabled="isFormSending"
              @click="sendForm"
              type="submit"
              class=" btn btn-block mybtn btn-primary tx-tfm email-verif-button"
            >
              {{ $t("accountVerification.form.sendForm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import OwnerService from "@/services/OwnerService";
import router from "@/router";

const ownerService = new OwnerService();

export default defineComponent({
  components: {},
  name: "AccountVerification",
  props: {
    token: String,
  },
  setup(props) {
    console.log("hey oh verifying email with token", props.token);

    const owner = ref({});

    onMounted(async () => {
      const serverResponse = await ownerService.getOwnerByVerificationToken(
        props.token
      );
      console.log("serverResponse", serverResponse);
      if (serverResponse.exists) {
        owner.value = serverResponse.owner;
      } else {
        router.replace("/login");
      }
    });
    return {
      owner,
    };
  },
  methods: {
    async sendForm() {
      console.log("send form", this.token);
      if (this.firstname == "" || this.lastname == "") {
        this.errorMessage = this.$t(
          "errors.accountVerification.formIncomplete"
        );
        // error
      } else {
        this.isFormSending = true;
        await ownerService.verifyAccount(
          this.firstname,
          this.lastname,
          this.headquarters_address,
          this.token
        );
        this.isSuccess = true;
        setTimeout(() => {
          window.location.reload();
        }, 4000);
      }
    },
  },
  data() {
    return {
      lastname: "",
      firstname: "",
      headquarters_address: "",
      errorMessage: "",
      isFormSending: false,
      isSuccess: false,
    };
  },
});
</script>

<style></style>
